import PatientAgeChart from "./PatientAgeChart";
import PatientGenderChart from "./PatientGenderChart";

function PatientAnalytics() {
  return (
    <div>
      <div class="row justify-content-start align-items-center p-1 ms-2 h-50 gap-2">
        <div class="col-2 border rounded">
          <PatientAgeChart/>
        </div>
        <div class="col-2 border rounded">
            <PatientGenderChart/>
        </div>
        <div class="col-8">
          
        </div>
      </div>
    </div>
  );
}

export default PatientAnalytics;